/*globals TimelineMax, ScrollMagic, Bounce, Stripe*/


function getTimeRemaining(endtime) {
    var dateTime = endtime.split(' ');
    var date = dateTime[0].split('-');
    var yyyy = date[0];
    var mm = date[1] - 1; // remove 1 from the month
    var dd = date[2];

    var time = dateTime[1].split(':');
    var h = time[0];
    var m = time[1];
    var s = time[2];

    endtime = new Date(yyyy, mm, dd, h, m, s);

    var timeRemaining = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((timeRemaining / 1000) % 60);
    var minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
    var hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
    var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));

    return {
        total: parseFloat(
            timeRemaining < 10 ? '0' + timeRemaining : timeRemaining
        ),
        days: parseFloat(days < 10 ? '0' + days : days),
        hours: parseFloat(hours < 10 ? '0' + hours : hours),
        minutes: parseFloat(minutes < 10 ? '0' + minutes : minutes),
        seconds: parseFloat(seconds < 10 ? '0' + seconds : seconds),
    };
}
if ($('.project-time-left').length) {
    var timer = $('.project-time-left');
    var countdown = timer.attr('data-end_date');
    var degreees = 0;

    var timerInterval = setInterval(function () {
        var time = getTimeRemaining(countdown);

        if (time.total <= 0) {
            // show the end time
            clearInterval(timerInterval);

            // remvoe the donation options and put in the thank you message
            $('.thank-you-outer-wrapper').show();
            $('.donation-outer-wrapper').remove();
        }

        timer.find('[data-input="days"]').html(time.days);
        timer.find('[data-input="hours"]').html(time.hours);
        timer.find('[data-input="minutes"]').html(time.minutes);
        timer.find('[data-input="seconds"]').html(time.seconds);

        // update the seconds
        if (degreees === 0) {
            degreees = (60 - time.seconds) * 6;
        } else {
            degreees += 6;
        }
        $('.clock .seconds').css({
            transform: `rotate(${degreees}deg)`,
        });

        // minutes
        var minutes = 60 - time.minutes;
        var clock = $('.clock');
        var circumference = parseFloat(
            clock.find('.minutes').attr('stroke-dasharray')
        );
        var dashoffset = circumference * (1 - (minutes * 1.6666666667) / 100);
        clock.find('.minutes').css({ strokeDashoffset: dashoffset + '' });
    }, 1000);
}


// Fix the header
if ($('.campaign-usd .sub-header').length) {
    // setup the scroll magic controller
    let headerController = new ScrollMagic.Controller();

    // fix the filters when it comes into view 
    let subHeaderScene = new ScrollMagic.Scene({
        triggerHook: 0,
        // offset: - ($('.page.home header.main').outerHeight() - 2),
        // offset: - $('.page.home header.main').outerHeight(),
        triggerElement: '.campaign-usd .sub-header'
    });
    subHeaderScene.setPin('.campaign-usd .sub-header');
    subHeaderScene.setClassToggle('.campaign-usd .sub-header', 'pinned');
    // subHeaderScene.addIndicators({ name: 'fix filters'});
    subHeaderScene.addTo(headerController);
}

if ($('.campaign-usd .sample-card').length) {
    TweenMax.set('.campaign-usd .sample-card #prize-1', {
        autoAlpha: 0,
        x: '100%',
        y: '10%',
        rotation: -5
    });

    TweenMax.set('.campaign-usd .sample-card #prize-2', {
        autoAlpha: 0,
        x: '-100%',
        y: '10%',
        rotation: 5
    });

    TweenMax.set('.campaign-usd .sample-card #prize-3', {
        autoAlpha: 0,
        x: '100%',
        y: '10%',
        rotation: -5
    });

    TweenMax.set('.campaign-usd .sample-card #prize-4', {
        autoAlpha: 0,
        x: '-100%',
        y: '10%',
        rotation: 5
    });

    TweenMax.set('.campaign-usd .sample-card #prize-5', {
        autoAlpha: 0,
        x: '100%',
        y: '10%',
        rotation: -5
    });

    TweenMax.set('.campaign-usd .buy-card', {
        autoAlpha: 0,
        scale: 0.3,
        rotation: 45
    });


    var cardController = new ScrollMagic.Controller();
    var height = $('.sample-card').height();

    let showCards = new TimelineMax();
    showCards.staggerTo('.card-prize', 0.3, {
        // ease: Bounce.easeOut,
        ease: "back.inOut(1.7)",
        x: '0%',
        y: '0%',
        rotation: 0,
        autoAlpha: 1
    }, 0.15, '0');
    showCards.staggerTo('.buy-card', 1, {
        ease: Bounce.easeOut,
        autoAlpha: 1,
        scale: 1,
        rotation: 0
    }, 0.4, '0.3');

    // var showCards = TweenMax.staggerTo('.card-prize', 1, {
    //     ease: Bounce.easeOut,
    //     x: '0%',
    //     y: '0%',
    //     rotation: 0,
    //     autoAlpha: 1
    // }, 0.4);

    new ScrollMagic.Scene({
        // duration: height,
        triggerHook: 'onEnter',
        offset: height / 4,
        triggerElement: ".sample-card"
    }).setTween(showCards)
    // .addIndicators({name: "showCards"})
    .addTo(cardController);

    // console.log(height);
}

// function setCardsWidth() {
//     if (!$('.scratch-cards-wrapper .cards').length) {
//         return;
//     }
//     // width: heigth / 100 * (100 / (16 / 9))
//     var width = ($('.scratch-cards-wrapper .cards').height() / 100) * 56.25;
//     document.documentElement.style.setProperty('--cards-width', width + 'px');
// }

// if ($('.scratch-cards-wrapper .cards').length) {
//     setCardsWidth();
//        $(window).resize(function () {
//         setCardsWidth();
//     });
// }

$('body').on('click', '.campaign-usd .donate-trigger', function () {
    $('.modal.add-donation-usd .select-card-trigger').removeClass('active');
    $('.modal.add-donation-usd').addClass('other');
    $('.add-donation-usd input[name="amount"]').val('0');
    $('.modal.add-donation-usd .other-amount input').select();
    openModal('.add-donation-usd');
    return false;
});

$('body').on('click', '.campaign-usd .to-how-it-works-trigger', function() {
    $('html, body').animate({
        scrollTop: $('.how-it-works').offset().top - 50
    }, 300);
    
    return false;
});

$('body').on('click', '.campaign-usd .to-cards-trigger', function() {
    $('html, body').animate({
        scrollTop: $('.add-donation-usd').offset().top - 50
    }, 300);
    
    return false;
});

function updateSummeryUSD() {
    // var selected = $('.campaign-usd .select-card-trigger.active');
    // var cards = selected.length ? parseFloat(selected.attr('data-cards')) : 0;
    var cards = 0;
    var amount = parseFloat($('.campaign-usd [name="amount"]').val());
    $('.campaign-usd .select-card-trigger').each(function() {
        var card = $(this);
        if(amount >= parseFloat(card.attr('data-amount'))) {
            cards = parseInt(card.attr('data-cards'));
        }
    });

    if ($('.campaign-usd .promo').length) {
        var promo = $('.campaign-usd .promo');
        if(promo.attr('data-mode') == 'cards') {
            cards+= parseFloat(promo.attr('data-cards'));
        }

        if (promo.attr('data-mode') == 'discount') {
            amount-= parseFloat(promo.attr('data-discount'));
        }
    }

    $('.campaign-usd .summery .total-amount').html(amount.toFixed(2));
    $('.campaign-usd .summery .total-cards').html(cards);
}

// validate the promo code
function validateUSDPromo() {
    $('.promo .code-error, .promo .invalid').hide();

    if ($('.add-donation-usd input[name="amount"]').length && parseFloat($('.add-donation-usd input[name="amount"]').val()) <= 0) {
        $('.promo .code-error').show();
        $('input[name="coupon"]').val('');
        return false;
    }

    $.ajax({
        type: 'POST',
        url: '/coupons',
        data: {
            '_token': $('meta[name="csrf-token"]').attr('content'),
            '_method': 'GET',
            'amount': $('.add-donation-usd input[name="amount"]').val(),
            'coupon': $('.add-donation-usd input[name="coupon"]').val()
        },
        dataType: 'json',
        success: function (data) {
            if (data.success) {
                $('.add-donation-usd .promo label').hide();
                // $('.add-donation-usd .promo .applied .code').html(data.code);
                // $('.add-donation-usd .promo .applied .cards').html(data.cards);
                $('.add-donation-usd .promo .applied').show();
                $('.add-donation-usd .promo .applied p').html(data.message);

                $('.add-donation-usd .promo').attr('data-mode', data.mode);
                $('.add-donation-usd .promo').attr('data-cards', data.cards);
                $('.add-donation-usd .promo').attr('data-discount', data.discount);
            } else {
                $('.add-donation-usd .promo .invalid').show();
                $('.add-donation-usd .promo label').show();
                $('.add-donation-usd .promo .applied').hide();
            }

            updateSummeryUSD();
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
}

$('body').on('click', '.campaign-usd .select-card-trigger', function() {
    var $this = $(this);
    var amount = $this.attr('data-amount');

    $('.campaign-usd .select-card-trigger').removeClass('active');
    $this.addClass('active');

    $('.campaign-usd .other-amount input').val(amount);
    $('.campaign-usd [name="amount"]').val(amount);
    $('.campaign-usd .select-card-trigger').removeClass('active');
    $('.campaign-usd .select-card-trigger[data-amount="' + amount + '"]').addClass('active');

    $('.add-donation-usd').removeClass('other');
    if ($this.parents('li').is(':last-child')) {
        $('.add-donation-usd').addClass('other');
    }

    updateSummeryUSD();
    $('.add-donation-usd .buy-cards').addClass('visible');

    if ($('.campaign-usd .promo').length && $('.campaign-usd .promo input').val()) {
        validateUSDPromo();
    }

    $('html, body').animate({
        scrollTop: $('.add-donation-usd .buy-cards').offset().top - 50
    }, 300);
    return false;
});

$('body').on('click', '.campaign-usd .donate-other-trigger', function () {
    $('.add-donation-usd .select-card-trigger').removeClass('active');
    $('.add-donation-usd').addClass('other');

    $('.add-donation-usd input[name="amount"]').val('0');
    $('.add-donation-usd .other-amount input').first().select();

    updateSummeryUSD();
    $('.add-donation-usd .buy-cards').addClass('visible');

    $('html, body').animate({
        scrollTop: $('.add-donation-usd').offset().top
    }, 300);
    return false;
});

$('body').on('click', '.campaign-usd .close-other-amount', function() {
    $('.add-donation-usd').removeClass('other');
    $('.campaign-usd .select-card-trigger').removeClass('active');
    $('.campaign-usd .other-amount input').val('0');
    $('.campaign-usd [name="amount"]').val('0');
    $('.add-donation-usd .buy-cards').removeClass('visible');
    updateSummeryUSD();
    return false;
});

$('body').on('blur', '.add-donation-usd .other-amount input', function() {
    var $this = $(this);
    var amount = parseFloat($this.val());
    amount = isNaN(amount) ? 0 : amount;
    $('.add-donation-usd [name="amount"]').val(amount);
    updateSummeryUSD();

    if ($('.campaign-usd .promo').length && $('.campaign-usd .promo input').val()) {
        validateUSDPromo();
    }
    
    return false;
});

$('body').on('blur', '.add-donation-usd input[name="coupon"]', function() {
    validateUSDPromo();
    return false;
});

$('body').on('click', '.add-donation-usd .remove-coupon', function() {
    $('.campaign-usd .promo input').val('');
    $('.add-donation-usd .promo').attr('data-mode', '');
    $('.add-donation-usd .promo').attr('data-cards', '');
    $('.add-donation-usd .promo').attr('data-discount', '');
    $('.add-donation-usd .promo .invalid').hide();
    $('.add-donation-usd .promo .applied').hide();
    $('.add-donation-usd .promo label').show();
    updateSummeryUSD();
    return false;
});


$('body').on('change', '.add-donation-usd [name="method"]', function() {
    var $this = $(this);
    var method = $this.val();
    
    if(method === 'card') {
        $('.add-donation-usd .card').parents('li').removeClass('hidden');
        $('.add-donation-usd .card').addClass('required');
        return false;
    }

    if(method === 'paypal') {
        $('.add-donation-usd .card').parents('li').addClass('hidden');
        $('.add-donation-usd .card').removeClass('required');
    }

});

// submit the donation
$('body').on('submit', '.add-donation-usd form', function() {
    var $this = $(this);

    var amount = parseFloat($('.add-donation-usd input[name="amount"]').val());
    amount = isNaN(amount) ? 0 : amount;
    if(!amount) {
        showNotice('Error', 'Please choose a card amount', 'close');
        return false;
    }

    var error = false;
    var emailError = false;
    $('.required', $this).each(function() {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('Error', 'Please fill out all required fields', 'close');
        return false;
    }

    if (emailError) {
        showNotice('Error', 'Please enter a valid email address', 'close');
        return false;
    }

    loading();

    // check if we are paypal
    var payload = {};

    if ($('.add-donation-usd [name="method"]:checked').val() === 'paypal') {
        payload['_token'] = $('meta[name="csrf-token"]').attr('content');
        payload.first_name = $('input[name="first_name"]', $this).val();
        payload.last_name = $('input[name="last_name"]', $this).val();
        payload.street = $('input[name="street"]', $this).val();
        payload.city = $('input[name="city"]', $this).val();
        payload.state = $('input[name="state"]', $this).val();
        payload.zip = $('input[name="zip"]', $this).val();
        payload.email = $('input[name="email"]', $this).val();
        payload.phone = $('input[name="phone"]', $this).val();
        payload.coupon = $('input[name="coupon"]', $this).val();
        payload.amount = $('input[name="amount"]', $this).val();
        payload.source = $('input[name="source"]', $this).val();
        payload.method = $('input[name="method"]:checked', $this).val();

        $.ajax({
            type: 'POST',
            url: $this.attr('action'),
            data: payload,
            dataType: 'json',
            success: function (data) {
                console.log(data);
                
                if (!data.success) {
                    unloading();
                    showNotice('Error', data.message, 'close');
                    return false;
                }
                
                if(data.location) {
                    window.location.href = data.location;
                    return false;
                }
                
                unloading();
                $this[0].reset();
                closeModal();
                showNotice('Success', data.message, 'close');
            },
            error: function (request) {
                console.log(request.responseText);
            }
        });

        return false;
    }

    // payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    // payload.first_name = $('input[name="first_name"]', $this).val();
    // payload.last_name = $('input[name="last_name"]', $this).val();
    // payload.street = $('input[name="street"]', $this).val();
    // payload.city = $('input[name="city"]', $this).val();
    // payload.state = $('input[name="state"]', $this).val();
    // payload.zip = $('input[name="zip"]', $this).val();
    // payload.email = $('input[name="email"]', $this).val();
    // payload.phone = $('input[name="phone"]', $this).val();
    // payload.coupon = $('input[name="coupon"]', $this).val();
    // payload.amount = $('input[name="amount"]', $this).val();
    // payload.source = $('input[name="source"]', $this).val();
    // payload.method = $('input[name="method"]:checked', $this).val();

    // payload.card_number = $('input[name="card_number"]', $this).val();
    // payload.cvv = $('input[name="cvv"]', $this).val();
    // payload.month = $('input[name="month"]', $this).val();
    // payload.year = $('input[name="year"]', $this).val();

    // $.ajax({
    //     type: 'POST',
    //     url: $this.attr('action'),
    //     data: payload,
    //     dataType: 'json',
    //     success: function (data) {
    //         console.log(data);

    //         if (!data.success) {
    //             unloading();
    //             showNotice('Error', data.message, 'close');
    //             return false;
    //         }

    //         if (data.location) {
    //             window.location.href = data.location;
    //             return false;
    //         }

    //         unloading();
    //         $this[0].reset();
    //         closeModal();
    //         showNotice('Success', data.message, 'close');
    //     },
    //     error: function (request) {
    //         console.log(request.responseText);
    //     }
    // });


    // setup the token
    Stripe.setPublishableKey($('meta[name="stripe"]').attr('content'));
    Stripe.card.createToken(
        {
            name: $('input[name="first_name"]', $this).val() + ' ' + $('input[name="last_name"]', $this).val(),
            number: $('input[name="card_number"]', $this).val(),
            cvc: $('input[name="cvv"]', $this).val(),
            exp_month: $('input[name="month"]', $this).val(),
            exp_year: $('input[name="year"]', $this).val(),
            address_line1: $('input[name="street"]', $this).val(),
            address_state: $('input[name="state"]', $this).val(),
            address_zip: $('input[name="zip"]', $this).val()
        },
        function(status, response) {
            // console.log(response);
            if (response.error) {
                unloading();
                showNotice('Error', response.error.message, 'close');
                return false;
            }

            payload['_token'] = $('meta[name="csrf-token"]').attr('content');
            payload.stripe_token = response.id;

            payload.first_name = $('input[name="first_name"]', $this).val();
            payload.last_name = $('input[name="last_name"]', $this).val();
            payload.street = $('input[name="street"]', $this).val();
            payload.city = $('input[name="city"]', $this).val();
            payload.state = $('input[name="state"]', $this).val();
            payload.zip = $('input[name="zip"]', $this).val();
            payload.email = $('input[name="email"]', $this).val();
            payload.phone = $('input[name="phone"]', $this).val();
            payload.brand = response.card.brand;
            payload.last_four = response.card.last4;
            payload.month = response.card.exp_month;
            payload.year = response.card.exp_year;
            payload.coupon = $('input[name="coupon"]', $this).val();
            payload.amount = $('input[name="amount"]', $this).val();
            payload.source = $('input[name="source"]', $this).val();
            payload.method = $('input[name="method"]:checked', $this).val();

            $.ajax({
                type: 'POST',
                url: $this.attr('action'),
                data: payload,
                dataType: 'json',
                success: function(data) {
                    console.log(data);
                    unloading();

                    if (!data.success) {
                        showNotice('Error', data.message, 'close');
                        return false;
                    }

                    $this[0].reset();
                    closeModal();
                    if(!data.cards.length) {
                        showNotice('Success', data.message, 'close');
                        return false;
                    }

                    // hide the purchase card option
                    $('.campaign-usd .sample-card').hide();
                    $('.campaign-usd .add-donation-usd').hide();

                    // if we have cards to show
                    if(data.cards.length) {
                        $('.campaign-usd .scratch-cards').show();
                        $.each(data.cards, function(index, card) {
                            var element = $('<div>', {
                                'class': 'card',
                                'html': `<div class="card-number">Card #${card.card_number}</div>

                                <div class="inner-wrapper">
                                    <div class="scratch-prize prize-1">
                                        <div class="prize" data-prize="prize_1">${card.prize_1}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <div class="scratch-prize prize-2">
                                        <div class="prize" data-prize="prize_2">${card.prize_2}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <div class="scratch-prize prize-3">
                                        <div class="prize" data-prize="prize_3">${card.prize_3}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <div class="scratch-prize prize-4">
                                        <div class="prize" data-prize="prize_4">${card.prize_4}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <div class="scratch-prize prize-5">
                                        <div class="prize" data-prize="prize_5">${card.prize_5}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 944.5 1702.7" style="enable-background:new 0 0 944.5 1702.7;" xml:space="preserve">
                                        <pattern id='prize1-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-1.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>
                                        <pattern id='prize2-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-2.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>
                                        <pattern id='prize3-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-3.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>
                                        <pattern id='prize4-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-4.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>
                                        <pattern id='prize5-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-5.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>

                                        <polygon id="prize-1-${card.card_number}" class="card-prize" fill="url(#prize1-${card.card_number})" points="0,0 0,296.6 944.5,394.4 944.5,0 "/>
                                        <polygon id="prize-2-${card.card_number}" class="card-prize" fill="url(#prize2-${card.card_number})" points="944.5,634.5 944.5,414.7 0,316.4 0,710.8 "/>
                                        <polygon id="prize-3-${card.card_number}" class="card-prize" fill="url(#prize3-${card.card_number})" points="0,730.5 0,950.3 944.5,1048.5 944.5,654.1 "/>
                                        <polygon id="prize-4-${card.card_number}" class="card-prize" fill="url(#prize4-${card.card_number})" points="944.5,1288.6 944.5,1068.8 0,970.6 0,1365 "/>
                                        <polygon id="prize-5-${card.card_number}" class="card-prize" fill="url(#prize5-${card.card_number})" points="0,1384.7 0,1702.6 944.5,1702.7 944.5,1308.3 "/>
                                    </svg>
                                </div>`
                            });

                            $('.campaign-usd .scratch-cards .cards').append(element);
                        });

                        var firstCard = $('.campaign-usd .scratch-cards .cards .card').first();
                        firstCard.addClass('active');
                        setupScratches(firstCard);

                        $('.next-card').hide();
                        if (data.cards.length > 1) {
                            $('.next-card').show();
                            $('.next-card [data-input="current"]').html(firstCard.index() + 1);
                            $('.next-card [data-input="total"]').html($('.scratch-cards .card').length);
                            // $('.next-card [data-input="total"]').html(data.cards.length);
                        }
                        

                        $('html, body').animate({
                            scrollTop: $('.scratch-cards').offset().top - 50
                        }, 300);
                    }

                    // if we are showing the more cards option
                    if (data.more_cards) {
                        $('.buy-more-cards').show();
                        $('.buy-more-options').html('');
                        $.each(data.more_cards.cards, function(index, card) {
                            $('.buy-more-options').append(`<a href="" class="buy-more" data-donation="${data.more_cards.donation}" data-card_token="${data.more_cards.card_token}" data-amount="${card.amount}">
                                <div class="cards">${card.cards} Card${parseInt(card.cards) > 1 ? 's' : ''}</div>
                                <div class="price">$${card.discount} (<span class="old">$${card.amount}</span>)</div>
                            </a>`);
                        });
                        console.log(data.more_cards);
                    }
                },
                error: function(request) {
                    console.log(request.responseText);
                }
            });

            return false;
        }
    );

    return false;
});

$('body').on('click', '.open-campaign-rules-usd', function () {
    openModal('.campaign-rules-usd');
    return false;
});


$('body').on('click', '.campaign-usd .auto-scartch', function () {
    $('.scratch-cards .card.active canvas').remove();
    return false;
});

$('body').on('click', '.campaign-usd .next-card', function () {
    var $this = $(this);
    var active = $('.scratch-cards .card.active');
    var next = active.next();

    active.removeClass('active');
    next.addClass('active');
    $('[data-input="current"]', $this).html(next.index() + 1);
    $('[data-input="total"]', $this).html($('.scratch-cards .card').length);

    setupScratches(next);

    $('html, body').animate({
        scrollTop: $('.scratch-cards').offset().top - 50
    }, 300);

    if(!next.next().length) {
        $this.hide();
    }
    
    return false;
});

$('body').on('click', '.campaign-usd .buy-more', function() {
    var $this = $(this);
    var payload = {};
    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    payload['card_token'] = $this.attr('data-card_token');
    payload['amount'] = $this.attr('data-amount');

    loading();
    $.ajax({
        type: 'POST',
        url: `donation/${$this.attr('data-donation')}/more`,
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showNotice('Error', data.message, 'close');
                return false;
            }

            closeModal();
            showNotice('Success', data.message, 'close');

            // if we have cards to show
            if (data.cards.length) {
                $('.campaign-usd .scratch-cards').show();
                $.each(data.cards, function (index, card) {
                    var element = $('<div>', {
                        'class': 'card',
                        'html': `<div class="card-number">Card #${card.card_number}</div>

                                <div class="inner-wrapper">
                                    <div class="scratch-prize prize-1">
                                        <div class="prize" data-prize="prize_1">${card.prize_1}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <div class="scratch-prize prize-2">
                                        <div class="prize" data-prize="prize_2">${card.prize_2}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <div class="scratch-prize prize-3">
                                        <div class="prize" data-prize="prize_3">${card.prize_3}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <div class="scratch-prize prize-4">
                                        <div class="prize" data-prize="prize_4">${card.prize_4}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <div class="scratch-prize prize-5">
                                        <div class="prize" data-prize="prize_5">${card.prize_5}</div>
                                        <canvas class="scratch" width="100" height="100"></canvas>
                                    </div>

                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 944.5 1702.7" style="enable-background:new 0 0 944.5 1702.7;" xml:space="preserve">
                                        <pattern id='prize1-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-1.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>
                                        <pattern id='prize2-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-2.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>
                                        <pattern id='prize3-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-3.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>
                                        <pattern id='prize4-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-4.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>
                                        <pattern id='prize5-${card.card_number}' width="1" height="1" viewBox="0 0 945 395">
                                            <image xlink:href='images/prize-5.jpg' width="945" height="395" preserveAspectRatio="none"></image>
                                        </pattern>

                                        <polygon id="prize-1-${card.card_number}" class="card-prize" fill="url(#prize1-${card.card_number})" points="0,0 0,296.6 944.5,394.4 944.5,0 "/>
                                        <polygon id="prize-2-${card.card_number}" class="card-prize" fill="url(#prize2-${card.card_number})" points="944.5,634.5 944.5,414.7 0,316.4 0,710.8 "/>
                                        <polygon id="prize-3-${card.card_number}" class="card-prize" fill="url(#prize3-${card.card_number})" points="0,730.5 0,950.3 944.5,1048.5 944.5,654.1 "/>
                                        <polygon id="prize-4-${card.card_number}" class="card-prize" fill="url(#prize4-${card.card_number})" points="944.5,1288.6 944.5,1068.8 0,970.6 0,1365 "/>
                                        <polygon id="prize-5-${card.card_number}" class="card-prize" fill="url(#prize5-${card.card_number})" points="0,1384.7 0,1702.6 944.5,1702.7 944.5,1308.3 "/>
                                    </svg>
                                </div>`
                    });

                    $('.campaign-usd .scratch-cards .cards').append(element);
                });

                $('.next-card').show();
                $('.next-card [data-input="current"]').html($('.scratch-cards .card.active').index() + 1);
                $('.next-card [data-input="total"]').html($('.scratch-cards .card').length);
            }

            // hide the option to buy more cards
            $('.buy-more-cards').hide();
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

var scratches = [];
var width = 0;
function detectLeftButton(event) {
    if ('buttons' in event) {
        return event.buttons === 1;
    } else if ('which' in event) {
        return event.which === 1;
    } else {
        return event.button === 1;
    }
}

function getBrushPos(index, xRef, yRef) {
    var scratchRect = scratches[index].scratch.getBoundingClientRect();

    // console.log('getBrushPos', index, xRef, yRef);
    // console.log(scratches[index]);
    // console.log(scratchRect);

    return {
        x: Math.floor((xRef - scratchRect.left) / (scratchRect.right - scratchRect.left) * scratches[index].scratch.width),
        y: Math.floor((yRef - scratchRect.top) / (scratchRect.bottom - scratchRect.top) * scratches[index].scratch.height)
    };
}


function drawDot(index, mouseX, mouseY) {
    scratches[index].scratchCanvas.beginPath();
    scratches[index].scratchCanvas.arc(mouseX, mouseY, scratches[index].brushRadius, 0, 2 * Math.PI, true);
    scratches[index].scratchCanvas.fillStyle = '#000';
    scratches[index].scratchCanvas.globalCompositeOperation = "destination-out";
    scratches[index].scratchCanvas.fill();
}

function setupScratches(card) {
    $('.scratch-prize', card).each(function () {
        var prize = $(this);

        var index = scratches.length;
        var setup = {};
        setup.scratch = $('canvas', prize)[0];
        width = prize.width() > width ? prize.width() : width;
        setup.scratch.width = width;
        setup.scratch.height = width;

        setup.scratchCanvas = setup.scratch.getContext('2d');
        setup.brushRadius = (setup.scratch.width / 100) * 5;
        if (setup.brushRadius < 20) {
            setup.brushRadius = 20
        }

        var img = new Image();
        img.onload = function () {
            setup.scratchCanvas.drawImage(img, 0, 0, setup.scratch.width, setup.scratch.height);
        }
        img.src = 'images/scratch-here.png';

        setup.scratch.addEventListener("mousemove", function (e) {
            var brushPos = getBrushPos(index, e.clientX, e.clientY);
            var leftBut = detectLeftButton(e);
            if (leftBut == 1) {
                drawDot(index, brushPos.x, brushPos.y);
            }
        }, false);

        setup.scratch.addEventListener("touchmove", function (e) {
            e.preventDefault();
            var touch = e.targetTouches[0];
            if (touch) {
                var y = touch.pageY;
                y -= $(window).scrollTop();
                var brushPos = getBrushPos(index, touch.pageX, y);
                drawDot(index, brushPos.x, brushPos.y);
            }
        }, false);

        scratches.push(setup);
    });
}

// $('.scratch-cards .card').each(function () {
//     var card = $(this);
//     setupScratches(card);
// });


if ($('.scratch-cards.rescratch .card').length) {
    $('.campaign-usd .scratch-cards').show();
    var card = $('.scratch-cards.rescratch .card').first();
    setupScratches(card);
}